import React, { Component } from "react"
import { Image } from "semantic-ui-react"
import { withTranslation } from "react-i18next"
import MaintenanceCard from "../../../images/dashboard/maintenance-card.svg"
import BadgeImage from "../../../images/dashboard/badge.svg"
import { routeChange, routerPaths } from "../../../v1/constants/paths"
import { withRouter } from "react-router-dom"

class UnlockMaintenanceCard extends Component {
  render() {
    const { t, history } = this.props
    return (
      <div
        className="unlock-maintenance-card"
        onClick={() => routeChange(history, routerPaths.membership)}
      >
        <div className="unlock-maintenance-card-content">
          <p className="card-primary-text">{t("unlockThePerksOfMaintenanceMsg")}</p>
          <p className="card-secondary-text">{t("enjoyExclusiveCarAdviseMsg")}</p>
        </div>
        <div className="unlock-maintenance-image-section">
          <Image className="maintenance-card-image" src={MaintenanceCard} />
          <Image className="maintenance-card-badge-image" src={BadgeImage} />
        </div>
      </div>
    )
  }
}
export default withRouter(withTranslation("justForYouCards")(UnlockMaintenanceCard))
